import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import ProductTable from "./productTable";

function ProductContainer() {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route path={`${path}`}>
          <ProductTable />
        </Route>
      </Switch>
    </>
  );
}

export default ProductContainer;
